import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('loyaltylion'),
  titleToId: true,
  titleToNamespace: true,
  hasConnectionStatus: true,
  defaultAuthenticationType: 'oauth2Bearer',
  avatarPath: avatars.loyaltylion,
  logoPath: logos.loyaltylion
});
